import { Link } from 'react-router-dom'
import { site } from '../content/site'
import styles from './Footer.module.css'

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <span className={styles.name}>{site.name}</span>
                <span>{site.footer.copyright}</span>
                <span>{site.footer.tagline}</span>
                {/* back-link to our sibling service; rel keeps referrer + follow */}
                <span className={styles.partner}>
                    {site.partner.footerNote}:{' '}
                    <a href={site.partner.href} target="_blank" rel="noopener">{site.partner.label} ↗</a>
                </span>
                <Link to="/faq" className={styles.privacy}>{site.footer.faq}</Link>
                <Link to="/privacy-policy" className={styles.privacy}>{site.footer.privacy}</Link>
            </div>
        </footer>
    )
}
